module.exports = __webpack_public_path__ + "static/media/ppe.cea6a738.svg";